import { isAxiosError } from 'axios'
import { ToastType, useToastStore } from '@/stores/toast.store.ts'

export function notifyApiError (baseMessage: string, error: unknown) {
  const toastStore = useToastStore()
  let finalMessage = baseMessage
  if (isAxiosError(error)) {
    const apiDescription = error.response?.data?.error_description || error.response?.data?.description || error.response?.data?.message || error.message
    if (apiDescription) {
      finalMessage = finalMessage + ' : ' + apiDescription
    }
  }
  toastStore.notify(finalMessage, ToastType.Error)
}
